import { Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";
import AddIcon from "@mui/icons-material/Add";
import { useGetDigsigCertQuery } from "../../store/feature/service/digsigApiSlice";
import DigsigCertSearch from "../../components/molecules/digsigCert/DigsigCertSearch";
import DigsigCertTable from "../../components/molecules/digsigCert/DigsigCertTable";
// import { useGetAllOcspListQuery } from '../../store/feature/service/satpasDeviceApiSlice';

const DigsigCert = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});
  const { digsigCert } = useAppSelector((state: RootState) => state.role);
  // const data: any = []
  // REGION: DISPATCH OCSP ALL
  // useEffect(()=> {
  //   dispatch(getAllOcspList(params))
  // },[params])

  const { data, isLoading } = useGetDigsigCertQuery(params);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    if (data) {
      console.log("data baru ===> ", data);
    }
  }, [data]);

  // REGION: RETURN TSX
  return (
    <ListDataSkeleton
      isLoading={isLoading}
      // isLoadingEvent={isLoadingEvent}
      titleWidth={"300px"}
    >
      <Grid container>
        <Grid item xs={10} md={10} lg={10} xl={10}>
          <Typography
            variant="h3"
            fontFamily="Open Sans"
            sx={{ marginY: "20px" }}
          >
            Digsig Certificate
          </Typography>
        </Grid>

        <Grid
          item
          xs={2}
          md={2}
          lg={2}
          xl={2}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {digsigCert.create && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/digsig-certificate/create")}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Upload
            </Button>
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <DigsigCertSearch params={params} setParams={setParams} />
          <DigsigCertTable
            data={data !== undefined && data !== null ? data?.data : []}
            params={params}
            setParams={setParams}
            defaultValue={defaultValue}
            setDefaultValue={setDefaultValue}
          />
        </Grid>
      </Grid>
    </ListDataSkeleton>
  );
};

export default DigsigCert;
